import { isAdminSection, type AdminSectionId } from "./adminRoute";

export const DEFAULT_ADMIN_SECTION: AdminSectionId = "overview";

const STORAGE_KEY = "admin-console.tab";

/**
 * Last section of this browser session. Only used when landing on bare
 * /admin; every other state lives in the URL. Storage may be unavailable.
 */
export function readLastSection(): AdminSectionId {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    return isAdminSection(stored) ? stored : DEFAULT_ADMIN_SECTION;
  } catch {
    return DEFAULT_ADMIN_SECTION;
  }
}

export function storeLastSection(section: AdminSectionId): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, section);
  } catch {
    // Best effort; the section still works without it.
  }
}
